import { CurrentLang } from './LocalisationUtils'

import Moment from 'moment';

export const EDateGrouping = {
	today: CurrentLang().patient_list_grouping_last_treated_today,
	yesterday: CurrentLang().patient_list_grouping_last_treated_yesterday,
	this_week: CurrentLang().patient_list_grouping_last_treated_this_week,
	last_week: CurrentLang().patient_list_grouping_last_treated_last_week,
	this_month: CurrentLang().patient_list_grouping_last_treated_this_month,
	last_month: CurrentLang().patient_list_grouping_last_treated_last_month,
	this_year: CurrentLang().patient_list_grouping_last_treated_this_year,
	older: CurrentLang().patient_list_grouping_last_treated_older,
}

// This script is released to the public domain and may be used, modified and
// distributed without restrictions. Attribution not necessary but appreciated.
// Source: https://weeknumber.net/how-to/javascript

// Returns the ISO week of the date.
function getWeek(This) {

    const date = new Date(This.getTime());
    date.setHours(0, 0, 0, 0);

    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);

    // January 4 is always in week 1.
    const week1 = new Date(date.getFullYear(), 0, 4);

    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}

// Returns the four-digit year corresponding to the ISO week of the date.
function getWeekYear(This) {
    var date = new Date(This.getTime());
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    return date.getFullYear();
}

export const DAY_AS_MINS = 24 * 60;
export const DAY_AS_SECS = DAY_AS_MINS * 60;
export const DAY_AS_MS = DAY_AS_SECS * 1000;

export function getDateGrouping(_dt) {
    const now = new Date();
    return __getDateGrouping(now, _dt)
}

export function __getDateGrouping(_now, _dt) {

    const today = new Date(_now);
    today.setHours(12,0,0,0);

    const date = new Date(_dt);
    date.setHours(12,0,0,0);

    if (today.getTime() === date.getTime()) {
        // console.log(`now = ${_now} date = ${_dt} returning ${EDateGrouping.today}`);
        return EDateGrouping.today;
    }

    if ((today.getTime() - DAY_AS_MS) === date.getTime()) {
        // console.log(`now = ${_now} date = ${_dt} returning ${EDateGrouping.yesterday}`);
        return EDateGrouping.yesterday;
    }
    else if ((today.getUTCFullYear() === date.getUTCFullYear())
            && (today.getUTCMonth() === date.getUTCMonth())
            && (today.getUTCDate() === (date.getUTCDate() + 1)) ) {

        // Handle daylight saving clock changes
        return EDateGrouping.yesterday;
    }

    const todayWeekYear = getWeekYear(today);
    const todayWeek = getWeek(today);

    const dateWeekYear = getWeekYear(date);
    const dateWeek = getWeek(date);

    if ((todayWeekYear === dateWeekYear) && (todayWeek === dateWeek)) {
        // console.log(`now = ${_now} date = ${_dt} returning ${EDateGrouping.this_week}`);
        return EDateGrouping.this_week;
    }

    const difference_ms = today.getTime() - date.getTime();
    const different_days = difference_ms / DAY_AS_MS;

    if (different_days <= 14) {
        if ( ((todayWeekYear === dateWeekYear) && (todayWeek-1 === dateWeek)) || ((todayWeekYear-1 === dateWeekYear) && (todayWeek === 1) && ((dateWeek === 52) || (dateWeek === 53))) ) {
                // console.log(`now = ${_now} date = ${_dt} returning ${EDateGrouping.last_week}`);
                return EDateGrouping.last_week;
        }
    }

    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth();

    const dateYear = date.getFullYear();
    const dateMonth = date.getMonth();

    if ((todayYear === dateYear) && (todayMonth === dateMonth)) {
        // console.log(`now = ${_now} date = ${_dt} returning ${EDateGrouping.this_month}`);
        return EDateGrouping.this_month;
    }

    if ( ((todayYear === dateYear) && (todayMonth-1 === dateMonth)) || ((todayYear-1 === dateYear) && (todayMonth === 0) && (dateMonth === 11)) ) {
        // console.log(`now = ${_now} date = ${_dt} returning ${EDateGrouping.last_month}`);
        return EDateGrouping.last_month;
    }

    if (todayYear === dateYear) {
        // console.log(`now = ${_now} date = ${_dt} returning ${EDateGrouping.this_year}`);
        return EDateGrouping.this_year;
    }

    // console.log(`now = ${_now} date = ${_dt} returning ${EDateGrouping.older}`);
    return EDateGrouping.older;
}

export function toDateStr(dt) {
    if (undefined === dt) {
        dt = new Date();
    }
    const retVal = Moment(dt).format("YYYY-MM-DD");
    //console.log(`#1637 toDateStr : ${dt} --> ${retVal}`);
    return retVal;
}

export function toUdiDateStr(dt) {
    if (undefined === dt) {
        dt = new Date();
    }
    const retVal = Moment(dt).format("YYMMDD");
    //console.log(`#1637 toUdiDateStr : ${dt} --> ${retVal}`);
    return retVal;
}



export function toUtcDateStr(dt) {
    if (undefined === dt) {
        dt = new Date();
    }
    const retVal = Moment(dt).utc().format("YYYY-MM-DD");
    //console.log(`#1637 toUtcDateStr : ${dt} --> ${retVal}`);
    return retVal;
}

export function dateMatches(lhs, rhs) {
    
    //console.log(`#1637 dateMatches : ${lhs} === ${rhs} ?`);
    
    if ((typeof lhs !== 'string') && !(lhs instanceof String)) {
        lhs = toUtcDateStr(lhs);
    }

    if ((typeof rhs !== 'string') && !(rhs instanceof String)) {
        rhs = toUtcDateStr(rhs);
    }

    //console.log(`#1637 dateMatches : ${lhs} === ${rhs} ?`);
    
    return lhs === rhs;
}
